import React, { useEffect, useState } from 'react';
import { Button, Form, Row, Space, Typography, Col } from 'antd';
import PromoTable from '../common/PromoTable';
import { getParams } from '../../../../utilities/filterConstructor';
import PromoCodeSearch from './PromoCodeSearch';
import { getCourses } from '../../../../services/courseService';
import './PromoCodes.css';
import PromoCodeAdd from './PromoCodeAdd';
import { getCourseOffers } from '../../../../services/courseOfferService';
import { getPromoCodes } from '../../../../services/promoCodeService';
import { Link } from 'react-router-dom';
import { formattedPromoCodeCsvData } from '../../../../utilities/formatData';
import { CSVLink } from 'react-csv';

const { Title } = Typography;
const COURSE_LIMIT = 1000;

const DiscountCountryCell = ({ countryWiseDiscounts }) => {
  if (!countryWiseDiscounts || !countryWiseDiscounts.length) {
    return 'All'
  }

  return (
    <>
      {countryWiseDiscounts.map((countryDiscount, index) => {
        const countryName = countryDiscount.country;
        return (
          <span key={countryName}>
              {countryName}{index !== countryWiseDiscounts.length - 1 ? ', ' : ''}
          </span>
        );
      })}
    </>
  );
};

const PromoCodeListingTab = () => {
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [offset, setOffset] = useState((current - 1) * pageSize);

  const [codes, setCodes] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [error, setError] = useState(false);
  const [currentParams, setCurrentParams] = useState({});
  const [fetching, setFetching] = useState(false);

  const [courses, setCourses] = useState([]);
  const [courseOffers, setCourseOffers] = useState([]);
  const [fetchingSearchData, setFetchingSearchData] = useState(false);

  const [csvReport, setCsvReport] = useState(null);

  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode',
  });

  const [visibleAddModal, setVisibleAddModel] = useState(false);
  const onClickModal = () => {
    setVisibleAddModel(true);
  };

  const columns = [
    {
      title: 'No',
      dataIndex: 'index',
      key: 'index',
      render: (value, item, index) => <span>{offset + index + 1}</span>,
    },
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
      render: (value, record) => (
        <Space size="middle">
          <Link to={'/promo/' + record._id}>{value}</Link>
        </Space>
      ),
    },
    {
      title: 'Is Active?',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (value) => <span>{value ? 'true' : 'false'}</span>,
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      render: (value) => <span>{value}</span>,
    },
    {
      title: 'Value',
      dataIndex: 'discountValue',
      key: 'discountValue',
      render: (value, record) => (
        <span>
          {record.discountType === 'amount_off' ? value / 100 : value}
        </span>
      ),
    },
    {
      title: 'Discount type',
      dataIndex: 'discountType',
      key: 'discountType',
      render: (value) => <span>{value}</span>,
    },
    {
      title: 'Courses allowed',
      key: 'coursesAllowed',
      dataIndex: 'coursesAllowed',
      render: (value) => {
        if (value) {
          return (
            <>
              {value.map((v, index) => {
                return (
                  <span key={index}>
                    {`${v}${index !== value.length - 1 ? ', ' : ''} `}
                  </span>
                );
              })}
            </>
          );
        }
      },
    },
    {
      title: 'Course offers allowed',
      key: 'courseOffersAllowed',
      dataIndex: 'courseOffersAllowed',
      render: (value) => {
        if (value) {
          return (
            <>
              {value.map((v, index) => {
                return (
                  <span key={index}>
                    {`${v}${index !== value.length - 1 ? ', ' : ''} `}
                  </span>
                );
              })}
            </>
          );
        }
      },
    },
    {
      title: 'Country discounts',
      key: 'countryWiseDiscounts',
      dataIndex: 'countryWiseDiscounts',
      render: (value) => <DiscountCountryCell countryWiseDiscounts={value}/>,
    },
    {
      title: 'Is Allowed in all countries?',
      dataIndex: 'allowInAllCountries',
      key: 'allowInAllCountries',
      render: (value) => <span>{value ? 'true' : 'false'}</span>,
    },
    {
      title: 'Referrer/Gifted by',
      dataIndex: 'metadata',
      key: 'metadata',
      render: (value, record) => {
        if (record.type === 'referral') {
          return (
            <span>
              {value?.referrerId ? value?.referrerId?.email : null}
              <br />
              <span>
                {value?.referrerId?.learnerId ? 'Learner' : 'Trainer'}
              </span>
            </span>
          );
        } else if (record.type === 'giftCard') {
          return <span>{value?.giftedBy ? value?.giftedBy?.email : null}</span>;
        } else {
          return null;
        }
      },
    },
    {
      title: 'Assigned to (gift)',
      key: 'assignedTo',
      dataIndex: 'assignedTo',
      render: (value) => {
        if (value) {
          return (
            <>
              {value.map((v, index) => {
                return (
                  <span key={index}>
                    {`${v}${index !== value.length - 1 ? ', ' : ''}`}
                  </span>
                );
              })}
            </>
          );
        }
      },
    },
    {
      title: 'No of usage',
      dataIndex: 'numberOfUsages',
      key: 'numberOfUsages',
      render: (value) => <span>{value}</span>,
    },
    {
      title: 'Max allowed usages',
      dataIndex: 'maxAllowedUsages',
      key: 'maxAllowedUsages',
      render: (value) => <span>{value}</span>,
    },
    {
      title: 'Max usage per person',
      dataIndex: 'maxUsagesPerPerson',
      key: 'maxUsagesPerPerson',
      render: (value) => <span>{value}</span>,
    },
    {
      title: 'Start date',
      dataIndex: 'startDate',
      key: 'startDate',
      render: (value) => <span>{new Date(value).toLocaleString()}</span>,
    },
    {
      title: 'End date',
      dataIndex: 'endDate',
      key: 'endDate',
      render: (value) => <span>{new Date(value).toLocaleString()}</span>,
    },
  ];

  const getData = async (
    newParams,
    limit = pageSize,
    currentPage = current
  ) => {
    const params = newParams ? newParams : currentParams;
    setFetching(true);
    await getPromoCodes(currentPage, limit, params)
      .then((res) => {
        if (!res.error) {
          setCodes(res.data.paginatedList);
          setTotalCount(res.data.totalCount);
        } else {
          setError(res.error);
        }
        setFetching(false);
      })
      .catch((e) => {
        console.log(e);
        setError(e);
        setFetching(false);
      });
  };

  const onPaginationChange = (data) => {
    getData(currentParams, data.pageSize, data.current).then();
    setCurrent(data.current);
    setPageSize(data.pageSize);
    setOffset((data.current - 1) * data.pageSize);
  };

  useEffect(() => {
    getData().then();
    fetchCourse();
    fetchCourseOffer();
  }, [current, currentParams]);

  const [form] = Form.useForm();

  const onSearch = (data) => {
    const params = getParams(data);
    setCurrentParams(params);
    setCurrent(1);
  };

  const onReset = () => {
    form.resetFields();
    setOffset(0);
    setCurrent(1);
    getData({}, pageSize, 1).then();
  };

  const fetchCourse = () => {
    setFetchingSearchData(true);
    getCourses(1, COURSE_LIMIT, {})
      .then((response) => {
        const data = response.data.paginatedList.map((course) => ({
          label: course.code,
          value: course.code,
        }));
        setCourses(data);
        setFetchingSearchData(false);
      })
      .catch((error) => {
        if (error?.response?.data?.message)
          setStatus({ type: 'ERROR', message: error.response.data.message });
        else
          setStatus({
            type: 'ERROR',
            message: 'Getting questions from the backend failed!',
          });
      });
  };

  const fetchCourseOffer = () => {
    setFetchingSearchData(true);
    getCourseOffers(1, COURSE_LIMIT, {})
      .then((response) => {
        const data = response.data.paginatedList.map((offer) => ({
          label: offer.code,
          value: offer.code,
        }));
        setCourseOffers(data);
        setFetchingSearchData(false);
      })
      .catch((error) => {
        if (error?.response?.data?.message)
          setStatus({ type: 'ERROR', message: error.response.data.message });
        else
          setStatus({
            type: 'ERROR',
            message: 'Getting questions from the backend failed!',
          });
      });
  };

  useEffect(() => {
    if (!csvReport && totalCount) {
      const fetchCsvData = async () => {
        try {
          const res = await getPromoCodes(1, totalCount, {});
          const data = res?.data?.paginatedList;
          const formattedCsvData = formattedPromoCodeCsvData(data);
          setCsvReport(formattedCsvData);
        } catch (e) {
          setCsvReport(null);
        }
      };

      fetchCsvData();
    }
  }, [totalCount]);

  return (
    <div className="c-PromoCodes">
      <div>
        <Row justify="space-between">
          <Col>
            <Space size="large">
              <Title level={3}>Promo Codes</Title>
            </Space>
          </Col>
          <Col>
            <Button type="ghost" onClick={onClickModal}>
              Add
            </Button>
          </Col>
        </Row>

        <PromoCodeAdd
          isOpen={visibleAddModal}
          toggle={() => setVisibleAddModel(false)}
          courses={courses}
          courseOffers={courseOffers}
          fetching={fetchingSearchData}
          setStatus={setStatus}
          status={status}
        />

        <section>
          <PromoCodeSearch
            onReset={onReset}
            onSearch={onSearch}
            form={form}
            initialValues={{ param: 'code' }}
            courses={courses}
            courseOffers={courseOffers}
          />
        </section>
        <section>
          {csvReport?.data && csvReport?.data?.length > 0 ? (
            <CSVLink
              data={csvReport.data}
              headers={csvReport.headers}
              filename={csvReport.filename}
            >
              Export to CSV
            </CSVLink>
          ) : null}
        </section>
        <section>
          <PromoTable
            data={codes}
            onPaginationChange={onPaginationChange}
            current={current}
            totalCount={totalCount}
            offset={offset}
            fetching={fetching}
            columns={columns}
          />
        </section>
      </div>
    </div>
  );
};

export default PromoCodeListingTab;
